import { Nav } from 'react-bootstrap';
import MessageListComponent from './MessageListComponent';

const PublishedMessageList = ({
  data,
  ListUser,
  selectedIndex,
  selectedTab,
}) => {
  return (
    <div>
      <div className="scroll">
        <Nav
          variant="pills"
          className="flex-column msggrpTabs message-mgt nav nav-pills"
        >
          {data.map((item, index) => (
            <MessageListComponent
              key={index}
              item={item}
              onClick={() => ListUser(index, item)}
              itemIndex={index}
              selectedIndex={selectedIndex}
              selectedTab={selectedTab}
            />
          ))}
        </Nav>
      </div>
    </div>
  );
};

export default PublishedMessageList;
